import React, { Component } from 'react';
import { Box, Button, ButtonBase, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { AlarmOff, Check, Close, HourglassTop, Refresh, Timer, TimerOff } from '@mui/icons-material';
import axios from 'axios';
import Global from '../../customlib/Global';
import Api from '../../customlib/Api';
import CheckpointDialog from './CheckPointDialog';

class CheckpointInfo extends Component {
    state = { 
        checkpointData: null,
        checkpointTimeOut: 0.5 * 60 * 1000,
        obTimeoutCheckpoint: null,
        successRate: "0%",
        missedRate: "0%",
        awaitingRate: "0%",
        isLoading: false,
        obInterval: null,
        showDialogWarning: false
     } 

    componentDidMount() {
        this.runCheckPoint();
    }

    componentWillUnmount(){
        if(this.state.obInterval != null){
            clearInterval(this.state.obInterval);
        }
    }

    handleShowDialogWarning = () => {
        this.setState({showDialogWarning: true});
    }

    handleCloseDialogWarning = () => {
        this.setState({showDialogWarning: false});
    }

    runCheckPoint = () => {
        this.handleLoadCheckpointData();
        let obInterval = setInterval(() => {
            this.handleLoadCheckpointData();
        }, 2 * 60 * 1000);

        this.setState({obInterval: obInterval});
    }

    handleLoadCheckpointData = () => {

        const params = {
            userId: Global.get().user.id, 
            appProfileId: Global.getAppProfile()._id
        }

        this.setState({isLoading: true}, () => {
            axios
                .post(Api.getRunningCheckpointByUserByApp(), params, Api.getRequestHeader())
                .then((response) => {
                    console.log("doSaveSales : ", response.data);
                    let responseData = response.data;
                    if(responseData.success){

                        const data = responseData.data;

                        if(data){
                            let successCount = data.successCount;
                            let missedCount = data.missedCount;
                            let awaitingCount = data.awaitingCount;

                            let totalCheckpoint = data.logs?.length;

                            if(totalCheckpoint > 0){
                                let successRate = (successCount/totalCheckpoint*100).toFixed(0);
                                let missedRate = (missedCount/totalCheckpoint*100).toFixed(0);
                                let awaitingRate = (awaitingCount/totalCheckpoint*100).toFixed(0);

                                this.setState({
                                    isLoading: false, 
                                    checkpointData: responseData.data, 
                                    successRate: successRate, 
                                    missedRate: missedRate, 
                                    awaitingRate: awaitingRate,
                                    showDialogWarning: !data.isRunning
                                });
                            }

                        }
                    }
                    
                })
                .catch((error) => {
                    this.setState({isLoading: false});
                    console.error("There was an error!", error);
                });
        });
    }

    render() { 

        if(!this.state.checkpointData){
            return (<></>)
        }

        return (
            <Box sx={{backgroundColor: "#FFF4E5", pl: "5px", pb: "5px", pr: "5px", borderRadius: "5px", border: "solid 1px", borderColor: "#f8c175"}}>
                <Box sx={{textAlign: "center", fontWeight: "bold", fontSize: "12px", mb: "0px"}}>
                    <Box textAlign={"left"}>{Global.getAppProfile().label}</Box>
                    <Grid container spacing={1}>
                        <Grid item xs={9} textAlign={"left"}>
                            Checkpoint Achievement
                        </Grid>
                        <Grid item xs={3} textAlign={"right"}>
                            <Tooltip title={"Reload Achievement"}>
                                <IconButton loading={this.state.isLoading}  sx={{width: "20px", height: "20px"}} size='small' onClick={this.handleLoadCheckpointData} variant='contained' color='primary'>
                                    {/* {this.state.isLoading && <CircularProgress color='#FFFFFF' size={"15px"} />} */}
                                    {!this.state.isLoading && <Refresh sx={{width: "15px", height: "15px"}} />}
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Box>
                {/* <CheckpointDialog /> */}
                <Grid container spacing={1}>
                    <Grid item xs={4} sx={{fontSize: "11px", cursor: "pointer"}}>
                        <Tooltip title={`Berhasil ${this.state.successRate}%`}>
                            <Box sx={{border: "solid 1px #1d05fa", borderRadius: "50px", height: "20px", backgroundColor: "#acbaf3"}} textAlign={"center"}>
                                <Check sx={{width: "15px", height: "15px"}} color='primary'/> {this.state.successRate}%
                            </Box>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={4} textAlign={"center"} sx={{fontSize: "11px", cursor: "pointer"}}>
                        <Tooltip title={`Terlewat ${this.state.missedRate}%`}>
                            <Box sx={{border: "solid 1px #fa1905", borderRadius: "50px", height: "20px", backgroundColor: "#fb9f9f"}} textAlign={"center"}>
                                <Close sx={{width: "15px", height: "15px"}} color='error'/> {this.state.missedRate}%
                            </Box>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={4} textAlign={"center"} sx={{fontSize: "11px", cursor: "pointer"}}>
                        <Tooltip title={`Tersisa ${this.state.checkpointData?.awaitingCount} dari ${this.state.checkpointData?.logs?.length} Checkpoint`}>
                            <Box sx={{border: "solid 1px #fadd05", borderRadius: "50px", height: "20px", backgroundColor: "#f7f2a0"}} textAlign={"center"}>
                                <HourglassTop sx={{width: "15px", height: "15px"}} color='warning'/> {this.state.checkpointData?.awaitingCount}
                            </Box>
                        </Tooltip>
                    </Grid>
                </Grid>

                <Dialog
                    open={this.state.showDialogWarning}
                    onClose={this.handleCloseDialogWarning}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    role="alertdialog"
                >
                    <Box sx={{backgroundColor: "#f3cdcd", p: "10px", border: "solid 0px #9d0505", borderRadius: "4px"}}>
                        <DialogTitle id="alert-dialog-title" sx={{textAlign: "center", color: "#fc0303", fontWeight: "bold"}}>
                            Checkpoint Issue!!!!
                        </DialogTitle>
                        <DialogContent sx={{textAlign: "center"}}>
                            <TimerOff sx={{width: "100px", height: "100px"}} color='error'/>
                            <h4 style={{color: "#fc0303"}}>{Global.getAppProfile().label}</h4>
                            <DialogContentText id="alert-dialog-description">
                                Notifikasi checkpoint kamu sedang di <span style={{color: "#fc0303", fontWeight: "bold"}}>TIDAK AKTIF</span>
                                <Box>Silakan re Login <strong>{Global.getAppProfile().label}</strong> untuk mengaktifkan kembali!</Box>
                            </DialogContentText>
                        </DialogContent>
                        <Button fullWidth variant='contained' color='error' onClick={this.handleCloseDialogWarning} autoFocus>
                            Oke
                        </Button>
                    </Box>
                </Dialog>

            </Box>
        );
    }
}
 
export default CheckpointInfo;